<div class="tunnel-product-list">
  @if (loading) {
    <ul class="products">
      @for (skeleton of skeletons; track $index) {
        <li>
          <ng-casto-tunnel-product-card [skeleton]="true"></ng-casto-tunnel-product-card>
        </li>
      }
    </ul>
  } @else if (!products.length) {
    <p class="no-product" [innerHTML]="emptyMessageKey | translate"></p>
  } @else {
    <ul class="products">
      @for (displayedProduct of products; track displayedProduct.product.ean) {
        <li>
          <ng-casto-tunnel-product-card [product]="displayedProduct"></ng-casto-tunnel-product-card>
        </li>
      }
    </ul>
  }
</div>
